import gql from "graphql-tag";

export const CREATE_CLUB_COACH_CHAT_MUTATION = gql`
  mutation createCoachingChatMutation($userId: ID, $coachId: ID, $description: String) {
    createCoachingChatMutation(userId: $userId, coachId: $coachId, description: $description) {
      success
      error
      id
    }
  }
`;

export const QUICK_RESOLVE_CHAT_MUTATION = gql`
  mutation quickResolveChatMutation(
    $chatId: ID!
    $text: String!
    $type: String!
    $userId: ID
    $remoteFile: String
    $attachmentType: String
    $sendEmailNotification: Boolean
  ) {
    quickResolveChatMutation(
      chatId: $chatId
      text: $text
      type: $type
      userId: $userId
      remoteFile: $remoteFile
      attachmentType: $attachmentType
      sendEmailNotification: $sendEmailNotification
    ) {
      success
    }
  }
`;
